import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WayFormsComponent } from './way-forms.component';
import { ErrorComponent } from './error/error.component';
import { SuccessComponent } from './success/success.component';
import { BadComponent } from './bad/bad.component';
import { MainComponent } from './main/main.component';

const routes: Routes = [
  {
    path: '',
    component: WayFormsComponent,
    children: [
      { path: 'error', component: ErrorComponent },
      { path: 'exito', component: SuccessComponent },
      { path: 'algo-salio-mal', component: BadComponent },
      { path: '', component: MainComponent },  // Ruta por defecto para MainComponent
      { path: ':idForm/:idActivity/:idRoutine', component: MainComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WayFormsRoutingModule { }
